import { Button, Input, Popconfirm, Space, Switch, message } from 'antd'
import React from 'react'
import API from '../../../../utils/api'
import { useToken } from '../../../hooks'

const SettingChange = ({ data, mutate = () => {} }) => {
	const type = data?.id?.split('_')[1]?.split(':')[0]
	const { data: token } = useToken()

	return (
		<Space.Compact>
			<Popconfirm
				title="해제하시겠습니까?"
				onConfirm={() => {
					API.send('DELETE', '/admin/ip', token + '', {
						ip: data?.ip,
					}).then(res => {
						message.success('해제되었습니다.')
						mutate()
					})
				}}>
				<Button type="primary" size="small">
					차단해제
				</Button>
			</Popconfirm>
		</Space.Compact>
	)
}

export default React.memo(SettingChange)
